export const cppBaseSex = ['男', '女', '未知'];

export const cppBaseAge = ['16-25岁', '26-35岁', '36-45岁', '46-55岁', '56岁以上', '未知'];

export const cppAddrProvince = [
  '广东',
  '上海',
  '云南',
  '北京',
  '吉林',
  '四川',
  '安徽',
  '山东',
  '广西',
  '新疆',
  '江苏',
  '河北',
  '浙江',
  '湖北',
  '湖南',
  '甘肃',
  '贵州',
  '辽宁',
  '重庆',
  '陕西',
];

export const isPlus = [
  {
    title: '会员',
    val: '1',
  },
  {
    title: '非会员',
    val: '0',
  },
];
